import { ExportReviewsCsvParams, GetReviewsParams, GetTracksForReviewsParams } from "../types/requestInputs";
import { GetReviewsResponse, GetTracksForReviewsResponse } from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

export const getReviews = async ({
    token,
    trackIds,
    startDate,
    endDate,
}: GetReviewsParams): Promise<GetReviewsResponse> => {
    return fetchAPI<GetReviewsResponse>(
        "/get-reviews",
        "POST",
        { trackIds: trackIds || [], startDate, endDate },
        token,
    );
};

export const getTracksForReviews = async ({
    token,
}: GetTracksForReviewsParams): Promise<GetTracksForReviewsResponse> => {
    return fetchAPI<GetTracksForReviewsResponse>("/get-tracks-for-reviews", "POST", {}, token);
};

// Streams a CSV blob and triggers a download — same flow as
// exportAnalyticsCsv. Kept inline (rather than going through fetchAPI) so we
// keep the Content-Disposition filename the server proposes.
export const exportReviewsCsv = async ({
    token,
    trackIds,
    startDate,
    endDate,
}: ExportReviewsCsvParams): Promise<void> => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    if (!baseUrl) {
        throw new Error("REACT_APP_API_BASE_URL environment variable is not defined");
    }

    const response = await fetch(`${baseUrl}/export-reviews-csv`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ trackIds: trackIds || [], startDate, endDate }),
    });

    if (!response.ok) {
        throw new Error(`Export failed with status ${response.status}`);
    }

    const csvContent = await response.text();
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = `reviews.csv`;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch) {
            filename = filenameMatch[1];
        }
    }

    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
